import type {
  HealthServiceSchema,
  PaginatedQueryRequest,
  PaginatedQueryResponse,
  QueryFnParams
} from '@libs/data-access/queries'
import { httpServices } from '@libs/data-access/queries'

export type FetchPaginatedHealthServicesOptions = QueryFnParams<{
  queryParams: PaginatedQueryRequest & {
    search_name?: string
  }
}>

export const fetchPaginatedHealthServices = async (
  opts: FetchPaginatedHealthServicesOptions
) => {
  const response = await httpServices.core.get<
    PaginatedQueryResponse<HealthServiceSchema>
  >('/employee_management/occupational_health_services', {
    params: opts.queryParams
  })

  return response.data
}
